<template>
    <div style="background-color: white; ">
        <!--<ModalHeader title="회원가입"></ModalHeader>-->
        <div style="overflow:auto; flex:1; background-color: white;  padding:16px 20px;">
            <div style="display:flex; justify-content: space-between; font-weight: 700">
                <div @click="() => { $GlobalStore.closeLastModal() }" style="color: #808080; padding-bottom: 16px; padding-right: 30px;">닫기</div>
                <!-- <div @click="regist">다음</div> -->
            </div>
            <div style="text-align: center; margin: 40px 0;">
                <div style="font-weight: 700; font-size: 32px; line-height: 46px;">계정 만들기</div>
                <div style="font-weight: 500; line-height: 24px;">사커하우에서 사용할 이메일과 비밀번호를<br>설정해주세요</div>
            </div>
            <div style="margin-bottom: 20px;">
                <div style="font-size: 14px; font-weight: 500; line-height: 24px; margin-bottom: 4px;">이메일</div>
                <input v-model="id" placeholder="사용할 이메일을 입력하세요" class="common_box" style="outline: none; width: 100%; border: none;">
                <div style="font-size: 12px;font-weight: 500;line-height: 20px; color: #606060;">사커하우의 계정으로 사용됩니다.</div>
            </div>
            <div>
                <div style="font-size: 14px; font-weight: 500; line-height: 24px; margin-bottom: 4px;">비밀번호</div>
                <div class="common_box" style="padding: 0">
                    <div style="border-bottom: 1px solid #ebebeb;">
                        <input v-model="password1" type="password" placeholder="비밀번호를 입력하세요" style="outline: none; border-radius: 12px; background-color: #f5f5f5; padding: 12px; padding-bottom: 8px; width: 100%; border: none;">
                    </div>
                    <div style="padding-left: 12px; padding-top: 8px; color: #808080; font-size: 12px;font-weight: 500;line-height: 20px;">비밀번호 확인</div>
                    <div>
                        <input v-model="password2" type="password" placeholder="비밀번호 확인" style="outline: none; border-radius: 12px; background-color: #f5f5f5; padding: 12px; padding-top: 8px; width: 100%; border: none;">
                    </div>
                </div>
                <div style="font-size: 12px;font-weight: 500;line-height: 20px; color: #606060;">숫자와 영문(대/소문자)가 포함된 8자 이상이어야 합니다.</div>
            </div>

            <!-- <div style="color:#101014; font-size:12px; margin-bottom:15px; margin-top:40px;">서비스 동의</div>
            <div class="agree_check_wrap" @click="toggleCheck(1)">
                <div class="agree_content">이용약관, 개인정보 수집 및 이용에 동의합니다.(필수)</div>
                <div class="check_border" >
                    <img v-if="agree[1]" class="check_img" :src="require('@/assets/img/check_filter.png')" >
                </div>
            </div>
            <div class="agree_check_wrap" @click="toggleCheck(2)">
                <div class="agree_content">위치기반 서비스 이용약관에 대해 동의합니다.(필수)</div>
                <div class="check_border" >
                    <img v-if="agree[2]" class="check_img" :src="require('@/assets/img/check_filter.png')" >
                </div>
            </div>
            <div class="agree_check_wrap" @click="toggleCheck(3)">
                <div class="agree_content">마케팅 메시지 수신을 원합니다.(선택)</div>
                <div class="check_border" >
                    <img v-if="agree[3]" class="check_img" :src="require('@/assets/img/check_filter.png')" >
                </div>
            </div>

            <div @click="() => {if(is_regist_active) regist();}" class="regist_btn" :class="{active : is_regist_active}" style="">동의하고 계속 진행하기</div> -->

        </div>
        <div style="background-color: #fff; height: 92px; padding: 0px 20px;">
            <div @click="regist" :class="id.length !== 0 && password1.length !== 0 && password2.length !== 0 ? 'active' : 'unactive'" style="height: 40px; font-size: 14px; margin-top: 12px; text-align: center; line-height: 40px; border-radius: 12px;">계정 만들기</div>
        </div>
    </div>
</template>

<script>
import { MEMBER_TYPE, REGIST_STEP } from "@/Constants";

export default {
    name: "MemberRegist",
    components: {
        // RadioBtn,
        // FormInput
    },
    props: {
        register_type: {
            type: Number,
            default: MEMBER_TYPE.USER
        },
        isLanding: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            id: '',
            name: '',
            phone: '',
            password1: '',
            password2: '',
            isSendAuthNumber: false,
            REGIST_STEP: REGIST_STEP,
            isAuthNumberChecked: false,
            authNumber: '',
            agree: {
                0: false,
                1: false,
                2: false,
                3: false
            },
            sex: '',
            password_mode: 'password',
            is_regist_active: false,
        }
    },
    watch: {
        id() {
            this.checkAllFilled();
        },
        password1() {
            this.checkAllFilled();
        },
        name() {
            this.checkAllFilled();
        },
        'agree.1': function () {
            this.checkAllFilled();
        },
        'agree.2': function () {
            this.checkAllFilled();
        }
    },
    methods: {
        checkAllFilled() {
            if (this.id.length > 0 && this.password1.length > 0 && this.name.length > 0 && this.agree[1] && this.agree[2]) {
                this.is_regist_active = true;
            } else {
                this.is_regist_active = false;
            }
        },
        togglePasswordMode() {
            if (this.password_mode === 'password') {
                this.password_mode = 'text';
            } else {
                this.password_mode = 'password';
            }
        },
        toggleCheck(index) {
            this.agree[index] = !this.agree[index];
        },
        checkAll() {
            const agreeCnt = Object.keys(this.agree).length;
            let flag = true;
            if (this.agree[0]) flag = false;

            for (let i = 0; i < agreeCnt; i++) {
                this.agree[i] = flag;
            }
        },

        // async sendAuthNumber(){
        //     if(!this.phone){
        //         this.$GlobalStore.showAlert('휴대폰번호를 입력해주세요.');
        //         return;
        //     }
        //
        //     const parameters = {};
        //     parameters.phone = this.phone;
        //
        //     const res = await this.$Axios.post('/api/auth/number', parameters);
        //     if(res.data.code === 0){
        //         this.isSendAuthNumber = true;
        //         this.isAuthNumberChecked = false;
        //         this.$GlobalStore.showAlert('전송되었습니다.');
        //     }else {
        //         alert(res.data.msg);
        //     }
        // },
        // async checkAuthNumber(){
        //     if(!this.authNumber){
        //         alert('인증번호를 입력해주세요.');
        //         return;
        //     }
        //
        //     if(!this.phone){
        //         alert('휴대폰번호를 입력해주세요.');
        //         return;
        //     }
        //
        //     const parameters = {};
        //     parameters.phone = this.phone;
        //     parameters.authNumber = this.authNumber;
        //
        //     const res = await this.$Axios.post('/api/auth/check', parameters);
        //     if(res.data.code === 0){
        //         alert('인증되었습니다.');
        //         this.isAuthNumberChecked = true;
        //     }else {
        //         alert(res.data.msg);
        //         return;
        //     }
        // },
        async regist() {
            if (!this.id) {
                alert('이메일을 입력해주세요.');
                return;
            }

            const emailPattern = /^(\w|-|\.)+@(\w|-|\.)+$/;
            if (!emailPattern.test(this.id)) {
                this.$GlobalStore.showAlert('이메일 형식이 맞지 않습니다.');
                return;
            }

            //숫자 영문 특문 확인
            const pattern1 = /[0-9]/;				// 숫자
            const pattern2 = /[a-zA-Z]/;			// 문자
            const pattern3 = /[~!@#$%^&*()_+|<>?:{}]/;	// 특수문자

            if ((!pattern1.test(this.password1) || !pattern2.test(this.password1) || !pattern3.test(this.password1)) && this.password1.length < 8) {
                this.$GlobalStore.showAlert('영문, 숫자, 특수문자 조합 8자리 이상 입력해주세요.');
                return
            }

            if (!this.password1 || !this.password1) {
                alert('비밀번호를 입력해주세요.');
                return;
            }

            if (this.password1 !== this.password2) {
                alert('비밀번호가 일치하지 않습니다.');
                return;
            }

            const parameters = {}
            parameters.id = this.id

            const res = await this.$Axios.get('/api/email/check', { params: parameters })

            if (res.data.code === 0) {
                // this.$GlobalStore.addModal('MemberRegistStepTwo', { id: this.id, password: this.password1, register_type: this.register_type, isLanding: this.isLanding })
                this.$GlobalStore.addModal('SignupCommonFrame', { type: REGIST_STEP, id: this.id, password: this.password1 })
            } else {
                this.$GlobalStore.showAlert(res.data.msg)
            }


        },
    },
    created() {
        this.regist = this.$Once(this.regist);
        this.sendAuthNumber = this.$Once(this.sendAuthNumber);

        const marketing_agree = localStorage.getItem('marketing_agree') ?? '';
        if (marketing_agree == '1') {
            this.agree[3] = true;
        }
    }
}
</script>

<style scoped>
* {
    font-family: var(--global-font-family);
}

.label_wrap {
    padding: 0px 15px;
    margin-top: 20px;
}

.agree_check_wrap {
    display: flex;
    align-items: center;
    margin-top: 12px;
}

.agree_content {
    flex: 1;
    font-size: 12px;
    color: #606060;
}

.input_explain {
    color: #808080;
    font-size: 10px;
    margin-top: 12px;
    margin-bottom: 20px;
}

.check_border {
    display: inline-block;
    width: 14px;
    height: 14px;
    border: 1px solid #D9D9D9;
    position: relative;
    border-radius: 3px;
}

.check_img {
    width: 13px;
    height: 10px;
    position: absolute;
    top: 0px;
}

.regist_btn {
    margin-top: 40px;
    width: 100%;
    height: 40px;
    line-height: 40px;
    background-color: #D9D9D9;
    color: white;
    font-weight: 500;
    border-radius: 5px;
    text-align: center;
}

.regist_btn.active {
    background-color: #ff6100
}

.active {
    background-color: var(--color-main);
    color: #fff;
}

.unactive {
    background-color: #f5f5f5;
    color: #d9d9d9;
}

.common_box {
    padding: 12px;
    background-color: #f5f5f5;
    border-radius: 12px;
}

input::placeholder {
    font-weight: 500;
    font-size: 16px;
    color: #bbbbbb;
}
</style>